
import './index.less'
import React from 'react'
const te = ['none', 'dotted', 'groove', 'dashed', 'double']
console.log(React)
export default function BasicsText(props) {
  const obj = props.ifon.isFrame ? {
    paddingTop: props.ifon.framePaddingTop,
    paddingBottom: props.ifon.framePaddingBottom,
    paddingLeft: props.ifon.framePaddingLeft,
    paddingRight: props.ifon.framePaddingRight,
    borderStyle: te[props.ifon.textStyle],
    borderColor: props.ifon.frameColor,
    borderWidth: props.ifon.thickness,
    borderRadius: props.ifon.fillet
  } : {}

  return (<div className={`BasicsText ${props.selectItem ? props.selectItem.id === props.compIfon.id ? 'active' : '' : ''}`}
    style={{
      paddingTop: props.ifon.paddingTop,
      paddingBottom: props.ifon.paddingBottom,
      paddingLeft: props.ifon.paddingLeft,
      paddingRight: props.ifon.paddingRight
    }}
  >
    <div className='BasicsText_seizeASeat' style={obj}>
      {!props.ifon.html ? '请在右侧中输入内容' : <div className='text' style={{
        color: props.ifon.color
      }} dangerouslySetInnerHTML={{ __html: props.ifon.html }}></div>}
    </div>
  </div>)
}
